import { Modal } from "antd";

const EnterpriseDetails = ({ isModal, setIsModal, data }) => {
  const company = data?.hiretalent || {};
  const fullName =
    data?.full_name ||
    `${data?.first_name || ""} ${data?.last_name || ""}`.trim();

  const contactName =
    company?.primary_contact_full_name ||
    company?.primary_contact_name ||
    "";

  return (
    <Modal
      className=""
      visible={isModal}
      onCancel={() => {
        setIsModal(false);
      }}
      centered={true}
      footer={null}
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body px-4 pb-5">
            <div>
              <h4 class="mb-1 ct_fs_20">Enterprise Details</h4>
            </div>
            <div class="d-flex align-items-start gap-3 justify-content-between mt-4 px-4 ct_flex_col_991 pb-3">
              <div class="d-flex align-items-center gap-3">
                <img
                  src={data?.profile_image || "/assets/img/user_profile.png"}
                  class="ct_img_56"
                />
                <div>
                  <h5 class="ct_fs_18 ct_fw_600 mb-1 me-1">
                    {company?.company_name || fullName || "-"}
                  </h5>
                  {fullName && (
                    <p className="mb-0 ct_grey_text">{fullName}</p>
                  )}
                </div>
                <div></div>
              </div>
            </div>
            <ul>
              {company?.company_name && (
                <li>
                  <strong class="ct_fw_600">Company Name :</strong>{" "}
                  <span class="">{company?.company_name}</span>
                </li>
              )}
              {data?.email && (
                <li class="d-flex align-items-center gap-2 mb-2">
                  <img src="/assets/img/mail_icon_345.svg" alt="" />
                  <span>{data?.email || "#N/A"}</span>
                </li>
              )}
              {data?.phone_number && (
                <li class="d-flex align-items-center gap-2 mb-2">
                  <img src="/assets/img/phone_789.svg" alt="" />
                  <span>
                    <strong class="ct_fw_600">Phone Number:</strong>{" "}
                    {data?.phone_number || "#N/A"}
                  </span>
                </li>
              )}
              {company?.company_website && (
                <li>
                  <strong class="ct_fw_600">Website :</strong>{" "}
                  <span class="">{company?.company_website}</span>
                </li>
              )}
              {company?.number_of_employees && (
                <li>
                  <strong class="ct_fw_600">Employees :</strong>{" "}
                  <span class="">{company?.number_of_employees}</span>
                </li>
              )}
              {company?.country && (
                <li>
                  <strong class="ct_fw_600">Country :</strong>{" "}
                  <span class="">{company?.country}</span>
                </li>
              )}
              {company?.state && (
                <li>
                  <strong class="ct_fw_600">State :</strong>{" "}
                  <span class="">{company?.state}</span>
                </li>
              )}
              {company?.city && (
                <li>
                  <strong class="ct_fw_600">City :</strong>{" "}
                  <span class="">{company?.city}</span>
                </li>
              )}
              {company?.address_1 && (
                <li>
                  <strong class="ct_fw_600">Address 1 :</strong>{" "}
                  <span class="">{company?.address_1}</span>
                </li>
              )}
              {company?.address_2 && (
                <li>
                  <strong class="ct_fw_600">Address 2 :</strong>{" "}
                  <span class="">{company?.address_2}</span>
                </li>
              )}
              {company?.zip_code && (
                <li>
                  <strong class="ct_fw_600">Zip Code :</strong>{" "}
                  <span class="">{company?.zip_code}</span>
                </li>
              )}
              {company?.time_zone && (
                <li>
                  <strong class="ct_fw_600">Time Zone :</strong>{" "}
                  <span class="">{company?.time_zone}</span>
                </li>
              )}
              {company?.language && (
                <li>
                  <strong class="ct_fw_600">Language :</strong>{" "}
                  <span class="">{company?.language}</span>
                </li>
              )}
              {contactName && (
                <li>
                  <strong class="ct_fw_600">Primary Contact :</strong>{" "}
                  <span class="">{contactName}</span>
                </li>
              )}
              {company?.primary_contact_job_title && (
                <li>
                  <strong class="ct_fw_600">Primary Job Title :</strong>{" "}
                  <span class="">{company?.primary_contact_job_title}</span>
                </li>
              )}
              {company?.primary_contact_work_email && (
                <li>
                  <strong class="ct_fw_600">Primary Work Email :</strong>{" "}
                  <span class="">{company?.primary_contact_work_email}</span>
                </li>
              )}
              {company?.primary_contact_phone_number && (
                <li>
                  <strong class="ct_fw_600">Primary Phone :</strong>{" "}
                  <span class="">{company?.primary_contact_phone_number}</span>
                </li>
              )}
              {company?.secondary_contact_full_name && (
                <li>
                  <strong class="ct_fw_600">Secondary Contact :</strong>{" "}
                  <span class="">{company?.secondary_contact_full_name}</span>
                </li>
              )}
              {company?.secondary_contact_job_title && (
                <li>
                  <strong class="ct_fw_600">Secondary Job Title :</strong>{" "}
                  <span class="">{company?.secondary_contact_job_title}</span>
                </li>
              )}
              {company?.secondary_contact_work_email && (
                <li>
                  <strong class="ct_fw_600">Secondary Work Email :</strong>{" "}
                  <span class="">{company?.secondary_contact_work_email}</span>
                </li>
              )}
              {company?.secondary_contact_phone_number && (
                <li>
                  <strong class="ct_fw_600">Secondary Phone :</strong>{" "}
                  <span class="">{company?.secondary_contact_phone_number}</span>
                </li>
              )}
              {company?.linkedin_company_page && (
                <li>
                  <strong class="ct_fw_600">LinkedIn :</strong>{" "}
                  <span class="">{company?.linkedin_company_page}</span>
                </li>
              )}
              {company?.hiring_needs && (
                <li>
                  <strong class="ct_fw_600">Hiring Needs :</strong>{" "}
                  <span class="">{company?.hiring_needs}</span>
                </li>
              )}
              {company?.engagement_type && (
                <li>
                  <strong class="ct_fw_600">Engagement Type :</strong>{" "}
                  <span class="">{company?.engagement_type}</span>
                </li>
              )}
              {company?.work_enviroment && (
                <li>
                  <strong class="ct_fw_600">Work Environment :</strong>{" "}
                  <span class="">{company?.work_enviroment}</span>
                </li>
              )}
              {company?.preferred_timezone && (
                <li>
                  <strong class="ct_fw_600">Preferred Timezone :</strong>{" "}
                  <span class="">{company?.preferred_timezone}</span>
                </li>
              )}
              {company?.communication_tools_used && (
                <li>
                  <strong class="ct_fw_600">Communication Tools :</strong>{" "}
                  <span class="">{company?.communication_tools_used}</span>
                </li>
              )}
              {company?.types_of_collaboration && (
                <li>
                  <strong class="ct_fw_600">Collaboration Type :</strong>{" "}
                  <span class="">{company?.types_of_collaboration}</span>
                </li>
              )}
              {company?.information_confirmed !== null &&
                company?.information_confirmed !== undefined && (
                  <li>
                    <strong class="ct_fw_600">Information Confirmed :</strong>{" "}
                    <span>{company?.information_confirmed ? "Yes" : "No"}</span>
                  </li>
                )}
              {company?.agree_contact_opportunities !== null &&
                company?.agree_contact_opportunities !== undefined && (
                  <li>
                    <strong class="ct_fw_600">Agree Contact Opportunities :</strong>{" "}
                    <span>
                      {company?.agree_contact_opportunities ? "Yes" : "No"}
                    </span>
                  </li>
                )}
              {data?.status && (
                <li>
                  <strong class="ct_fw_600">Status :</strong>{" "}
                  <span class="">{data?.status}</span>
                </li>
              )}
              {company?.company_bio && (
                <div className="mt-3">
                  <p className="ct_fs_16 mb-1">Company Bio</p>
                  <p className="mb-0 ct_fs_14 ct_para_scroll ct_custom_scroll">
                    {company?.company_bio || "#N/A"}
                  </p>
                </div>
              )}
            </ul>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default EnterpriseDetails;
